import { Badge } from "@/components/ui/badge";
import { getKennelStatusBadgeClass, formatKennelStatus } from "@/lib/badge-styles";
import { LabelWithHover } from "@/components/ui/LabelWithHover";

function daysInStatus(since: string | null | undefined): number | null {
  if (!since) return null;
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(since);
  const d = new Date(isDateOnly ? since + "T00:00:00" : since);
  if (isNaN(d.getTime())) return null;
  return Math.max(0, Math.round((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24)));
}

interface StatusDaysBadgeProps {
  status?: string | null;
  substatus?: string | null;
  statusSince?: string | null;
  isApprox?: boolean;
  isOutcomed?: boolean;
  className?: string;
  "data-testid"?: string;
}

export function StatusDaysBadge({
  status,
  substatus,
  statusSince,
  isApprox,
  isOutcomed,
  className = "",
  "data-testid": testId,
}: StatusDaysBadgeProps) {
  if (isOutcomed) {
    return (
      <Badge className={`bg-muted text-muted-foreground border border-border ${className}`} data-testid={testId}>
        Outcomed
      </Badge>
    );
  }

  const label = formatKennelStatus(status, substatus);
  const days = daysInStatus(statusSince);
  const dayText = days !== null
    ? `${isApprox ? "~" : ""}${days} day${days !== 1 ? "s" : ""} in this status`
    : null;

  return (
    <Badge className={`${getKennelStatusBadgeClass(status)} ${className}`} data-testid={testId}>
      <LabelWithHover label={label} hoverContent={dayText} showUnderline={false} />
    </Badge>
  );
}
